import { useSelector } from 'react-redux'
import { activeDeliveryDate } from 'src/redux-api-bridge/selectors'
import { gql, useQuery } from '@apollo/client'
import moment from 'moment'

const GET_ESTIMATED_DELIVERY_DATE = gql`
  query getEstimatedDeliveryDate($deliveryDate: String!) {
    getEstimatedDeliveryDate(deliveryDate: $deliveryDate) {
      estimatedDeliveryDate
    }
  }
`

export const useWineDeliveryDate = ({
  hasWine,
  date
}: {
  hasWine?: boolean
  date?: string
}) => {
  const selectedDate = useSelector(activeDeliveryDate)
  const deliveryDate = date ?? selectedDate?.date

  const { data } = useQuery<{
    getEstimatedDeliveryDate: {
      estimatedDeliveryDate: string
    }
  }>(GET_ESTIMATED_DELIVERY_DATE, {
    variables: { deliveryDate },
    skip: !hasWine || !deliveryDate
  })

  const estimatedDeliveryDate =
    data?.getEstimatedDeliveryDate?.estimatedDeliveryDate

  if (!estimatedDeliveryDate) {
    return '-'
  }

  return moment(estimatedDeliveryDate).format('ddd, MMM. D')
}
